import { useState } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import SEOHead from '@/components/feature/SEOHead';

const recrutementSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Recrutement CasaReNovaPlus Neuenegg - Offres d'emploi Rénovation CVSE",
  "description": "Rejoignez l'équipe CasaReNovaPlus à Neuenegg. Postes ouverts : électricien certifié, technicien maintenance, artisan rénovation. CDI, salaires compétitifs.",
  "url": `${import.meta.env.VITE_SITE_URL}/recrutement`,
  "publisher": {
    "@type": "Organization",
    "name": "CasaReNovaPlus",
    "url": `${import.meta.env.VITE_SITE_URL}`,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Austrasse 95",
      "addressLocality": "Neuenegg",
      "addressRegion": "Fribourg",
      "postalCode": "3176",
      "addressCountry": "CH"
    },
    "telephone": "+41797616282"
  },
  "mainEntity": [
    {
      "@type": "JobPosting",
      "title": "Électricien Certifié",
      "description": "Réaliser des installations électriques conformes aux normes NIBT/OIBT à Genève. Dépannage, tableaux électriques, domotique KNX.",
      "datePosted": "2026-04-06",
      "employmentType": "FULL_TIME",
      "hiringOrganization": {
        "@type": "Organization",
        "name": "HB SERVICES",
        "sameAs": `${import.meta.env.VITE_SITE_URL}`
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Meyrin",
          "addressRegion": "Genève",
          "addressCountry": "CH"
        }
      },
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "CHF",
        "value": { "@type": "QuantitativeValue", "minValue": 5500, "maxValue": 7000, "unitText": "MONTH" }
      }
    },
    {
      "@type": "JobPosting",
      "title": "Technicien Maintenance Multi-Services",
      "description": "Maintenance préventive et corrective des installations CVSE à Genève. Dépannage urgence 24/7.",
      "datePosted": "2026-04-06",
      "employmentType": "FULL_TIME",
      "hiringOrganization": {
        "@type": "Organization",
        "name": "HB SERVICES",
        "sameAs": `${import.meta.env.VITE_SITE_URL}`
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Meyrin",
          "addressRegion": "Genève",
          "addressCountry": "CH"
        }
      },
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "CHF",
        "value": { "@type": "QuantitativeValue", "minValue": 4800, "maxValue": 6500, "unitText": "MONTH" }
      }
    }
  ]
};

const jobs = [
  {
    id: 1,
    title: 'Électricien Certifié',
    type: 'CDI',
    location: 'Genève / Meyrin',
    icon: 'ri-flashlight-line',
    color: 'bg-amber-500',
    colorLight: 'bg-amber-50',
    colorText: 'text-amber-600',
    colorBorder: 'border-amber-200',
    salary: '5\'500 – 7\'000 CHF/mois',
    experience: '3 ans minimum',
    urgent: true,
    description: 'Nous recherchons un électricien certifié pour rejoindre notre équipe technique à Genève. Vous interviendrez sur des chantiers résidentiels et commerciaux pour des installations, rénovations et dépannages électriques.',
    missions: [
      'Réaliser des installations électriques conformes aux normes NIBT/OIBT',
      'Effectuer des diagnostics et dépannages sur installations existantes',
      'Poser et raccorder tableaux électriques, prises, éclairages',
      'Installer des bornes de recharge pour véhicules électriques',
      'Participer aux projets de domotique KNX',
      'Rédiger les rapports d\'intervention et fiches de contrôle',
    ],
    requirements: [
      'CFC d\'électricien ou équivalent reconnu en Suisse',
      'Autorisation de travail en Suisse obligatoire',
      '3 ans d\'expérience minimum dans le domaine',
      'Connaissance des normes NIBT et OIBT suisses',
      'Permis de conduire B',
      'Rigueur, autonomie et sens du service client',
    ],
    benefits: [
      'Véhicule de service fourni',
      'Outillage professionnel complet',
      'Formation continue prise en charge',
      'Assurance maladie complémentaire',
      'Primes de performance',
    ],
  },
  {
    id: 2,
    title: 'Technicien Maintenance Multi-Services',
    type: 'CDI',
    location: 'Genève / Canton',
    icon: 'ri-tools-line',
    color: 'bg-teal-500',
    colorLight: 'bg-teal-50',
    colorText: 'text-teal-600',
    colorBorder: 'border-teal-200',
    salary: '4\'800 – 6\'500 CHF/mois',
    experience: '2 ans minimum',
    urgent: true,
    description: 'Rejoignez notre équipe de maintenance pour assurer l\'entretien et le dépannage d\'installations techniques variées chez nos clients résidentiels et professionnels dans tout le canton de Genève.',
    missions: [
      'Assurer la maintenance préventive et corrective des installations',
      'Diagnostiquer et réparer les pannes (chauffage, plomberie, électricité)',
      'Réaliser les contrôles périodiques et rédiger les rapports',
      'Gérer les interventions d\'urgence 24/7 en rotation',
      'Conseiller les clients sur l\'entretien de leurs équipements',
      'Gérer le stock de pièces détachées du véhicule',
    ],
    requirements: [
      'Formation technique (CFC ou équivalent) dans un corps de métier du bâtiment',
      'Expérience en maintenance multi-technique souhaitée',
      'Bonnes connaissances en électricité, plomberie ou chauffage',
      'Permis de conduire B obligatoire',
      'Disponibilité pour les astreintes d\'urgence',
      'Excellent relationnel client',
    ],
    benefits: [
      'Véhicule de service avec outillage complet',
      'Téléphone professionnel',
      'Primes d\'astreinte et d\'urgence',
      'Mutuelle santé avantageuse',
      'Tickets restaurant',
    ],
  },
  {
    id: 3,
    title: 'Agent de Nettoyage & Conciergerie',
    type: 'CDI / Temps partiel possible',
    location: 'Genève et environs',
    icon: 'ri-brush-line',
    color: 'bg-emerald-500',
    colorLight: 'bg-emerald-50',
    colorText: 'text-emerald-600',
    colorBorder: 'border-emerald-200',
    salary: '3\'800 – 4\'800 CHF/mois',
    experience: '1 an minimum',
    urgent: false,
    description: 'Nous recrutons des agents de nettoyage sérieux et motivés pour assurer l\'entretien de résidences, bureaux et espaces commerciaux à Genève. Travail en équipe dans une ambiance professionnelle et bienveillante.',
    missions: [
      'Nettoyage et entretien de résidences privées et appartements',
      'Nettoyage de bureaux, commerces et espaces communs',
      'Conciergerie d\'immeubles (parties communes, caves, parkings)',
      'Nettoyage de fin de chantier et remise en état',
      'Utilisation de produits écologiques certifiés',
      'Respect des protocoles d\'hygiène et de sécurité',
    ],
    requirements: [
      'Expérience en nettoyage professionnel souhaitée',
      'Sérieux, ponctualité et discrétion indispensables',
      'Capacité à travailler en autonomie et en équipe',
      'Permis de conduire B apprécié',
      'Autorisation de travail en Suisse obligatoire',
      'Maîtrise du français (niveau B1 minimum)',
    ],
    benefits: [
      'Équipements et produits fournis',
      'Horaires flexibles adaptables',
      'Formation aux techniques professionnelles',
      'Ambiance de travail conviviale',
      'Possibilité d\'évolution vers chef d\'équipe',
    ],
  },
  {
    id: 4,
    title: 'Aide à Domicile / Auxiliaire de Vie',
    type: 'CDI / Temps partiel',
    location: 'Genève',
    icon: 'ri-heart-line',
    color: 'bg-rose-500',
    colorLight: 'bg-rose-50',
    colorText: 'text-rose-600',
    colorBorder: 'border-rose-200',
    salary: '3\'600 – 4\'500 CHF/mois',
    experience: 'Débutant accepté',
    urgent: false,
    description: 'Vous souhaitez donner du sens à votre travail en aidant des personnes âgées ou dépendantes à maintenir leur autonomie à domicile ? Rejoignez notre équipe d\'aide à domicile bienveillante et professionnelle.',
    missions: [
      'Aide aux tâches ménagères (ménage, lessive, repassage)',
      'Accompagnement aux courses et rendez-vous médicaux',
      'Préparation des repas selon les régimes alimentaires',
      'Présence et soutien moral auprès des personnes isolées',
      'Aide à la mobilité et aux déplacements dans le logement',
      'Liaison avec les familles et les équipes soignantes',
    ],
    requirements: [
      'Empathie, patience et bienveillance essentielles',
      'Expérience auprès de personnes âgées appréciée',
      'Formation CFC assistant socio-éducatif ou équivalent (un plus)',
      'Permis de conduire B apprécié',
      'Disponibilité en semaine et certains weekends',
      'Maîtrise du français obligatoire',
    ],
    benefits: [
      'Formation interne complète assurée',
      'Accompagnement et suivi régulier',
      'Remboursement des frais de transport',
      'Ambiance humaine et solidaire',
      'Horaires adaptés à votre situation',
    ],
  },
];

export default function Recrutement() {
  const [selectedJob, setSelectedJob] = useState<number | null>(null);
  const [formJob, setFormJob] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const openModal = (jobId: number, jobTitle: string) => {
    setSelectedJob(jobId);
    setFormJob(jobTitle);
  };

  const closeModal = () => {
    setSelectedJob(null);
    if (!submitted) setFormJob('');
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    Array.from(form.elements).forEach((el) => {
      const input = el as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
      if (input.name) {
        if (input.type === 'checkbox') {
          if ((input as HTMLInputElement).checked) data.append(input.name, input.value);
        } else {
          data.append(input.name, input.value);
        }
      }
    });
    try {
      await fetch('https://readdy.ai/api/form/d782h53ll6jbq2vdd3o0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Recrutement Neuenegg | Offres d'emploi Rénovation CVSE - CasaReNovaPlus"
        description="Rejoignez CasaReNovaPlus à Neuenegg. Postes ouverts : électricien certifié NIBT, technicien maintenance, artisan rénovation. CDI, salaires compétitifs, formation continue."
        keywords="recrutement Genève, emploi électricien Genève, technicien maintenance Genève, offre emploi CVSE Suisse romande, CDI Genève, emploi plombier Genève, agent nettoyage Genève"
        canonical={`${import.meta.env.VITE_SITE_URL}/recrutement`}
        schema={recrutementSchema}
      />
      <Header />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20professional%20team%20working%20together%20in%20bright%20office%20Geneva%20Switzerland%20diverse%20employees%20collaboration%20business%20environment%20clean%20minimal%20interior%20natural%20light&width=1920&height=700&seq=recrutement-hero-hb-001&orientation=landscape"
            alt="Rejoindre HB Services"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-teal-900/90 via-teal-800/80 to-teal-700/60"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 bg-white/15 border border-white/25 text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-6 backdrop-blur-sm">
              <span className="w-2 h-2 rounded-full bg-yellow-300 animate-pulse"></span>
              Recrutement ouvert — Genève
            </span>
            <h1 className="text-4xl md:text-6xl font-black text-white leading-tight mb-6">
              Rejoignez<br />
              <span className="text-teal-300">CasaReNovaPlus</span>
            </h1>
            <p className="text-white/80 text-lg leading-relaxed mb-8 max-w-xl">
              Nous sommes en pleine croissance et cherchons des talents motivés pour renforcer notre équipe multi-services à Genève. Rejoignez une entreprise dynamique, humaine et en plein essor.
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="#offres"
                className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-400 text-white font-semibold px-7 py-3.5 rounded-xl transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-briefcase-line"></i>
                Voir les offres
              </a>
              <a
                href="#candidature"
                className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 border border-white/30 text-white font-semibold px-7 py-3.5 rounded-xl transition-all cursor-pointer whitespace-nowrap backdrop-blur-sm"
              >
                <i className="ri-send-plane-line"></i>
                Candidature spontanée
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Chiffres */}
      <section className="bg-teal-600 py-10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            {[
              { value: '4', label: 'Postes ouverts', icon: 'ri-briefcase-line' },
              { value: '20+', label: 'Projets réalisés', icon: 'ri-building-line' },
              { value: '8', label: 'Services proposés', icon: 'ri-stack-line' },
              { value: '24/7', label: 'Disponibilité', icon: 'ri-time-line' },
            ].map((stat, i) => (
              <div key={i} className="text-white">
                <div className="w-10 h-10 flex items-center justify-center bg-white/15 rounded-xl mx-auto mb-2">
                  <i className={`${stat.icon} text-lg`}></i>
                </div>
                <div className="text-3xl font-black mb-1">{stat.value}</div>
                <div className="text-white/70 text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pourquoi nous rejoindre */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Pourquoi rejoindre CasaReNovaPlus ?</h2>
            <p className="text-gray-500 max-w-xl mx-auto">Une entreprise à taille humaine où chaque collaborateur compte et évolue.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: 'ri-rocket-line', title: 'Entreprise en croissance', desc: 'CasaReNovaPlus se développe rapidement. Rejoignez-nous et grandissez avec nous.', color: 'text-teal-600', bg: 'bg-teal-50' },
              { icon: 'ri-team-line', title: 'Ambiance conviviale', desc: 'Une équipe soudée, bienveillante et professionnelle. Ici, chaque voix compte et chaque idée est écoutée.', color: 'text-rose-600', bg: 'bg-rose-50' },
              { icon: 'ri-graduation-cap-line', title: 'Formation continue', desc: 'Nous investissons dans vos compétences : formations certifiantes, nouvelles technologies, évolution de carrière.', color: 'text-amber-600', bg: 'bg-amber-50' },
              { icon: 'ri-map-pin-line', title: 'Basé à Genève', desc: 'Interventions dans tout le canton. Pas de longs déplacements, vous travaillez près de chez vous.', color: 'text-emerald-600', bg: 'bg-emerald-50' },
              { icon: 'ri-coins-line', title: 'Salaires compétitifs', desc: 'Rémunération attractive selon les standards suisses, primes de performance et avantages sociaux.', color: 'text-violet-600', bg: 'bg-violet-50' },
              { icon: 'ri-shield-check-line', title: 'Stabilité & sécurité', desc: 'Contrats CDI, couverture sociale complète, assurance maladie complémentaire prise en charge.', color: 'text-cyan-600', bg: 'bg-cyan-50' },
            ].map((item, i) => (
              <div key={i} className="bg-white rounded-2xl p-6 border border-gray-100">
                <div className={`w-12 h-12 flex items-center justify-center ${item.bg} rounded-xl mb-4`}>
                  <i className={`${item.icon} text-xl ${item.color}`}></i>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Offres d'emploi */}
      <section id="offres" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-14">
            <span className="text-sm font-semibold text-teal-600 tracking-widest uppercase">Postes disponibles</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4">Nos offres d'emploi</h2>
            <p className="text-gray-500 max-w-xl mx-auto">Découvrez nos postes ouverts et trouvez celui qui correspond à votre profil.</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {jobs.map((job) => (
              <div key={job.id} className={`bg-white rounded-2xl border-2 ${job.colorBorder} overflow-hidden hover:-translate-y-1 transition-all`}>
                {/* Card header */}
                <div className={`${job.colorLight} px-6 py-5 flex items-start justify-between gap-4`}>
                  <div className="flex items-center gap-4">
                    <div className={`w-12 h-12 flex items-center justify-center ${job.color} rounded-xl flex-shrink-0`}>
                      <i className={`${job.icon} text-xl text-white`}></i>
                    </div>
                    <div>
                      <div className="flex items-center gap-2 flex-wrap">
                        <h3 className="font-bold text-gray-900 text-lg">{job.title}</h3>
                        {job.urgent && (
                          <span className="text-xs font-bold bg-red-100 text-red-600 px-2 py-0.5 rounded-full">Urgent</span>
                        )}
                      </div>
                      <div className="flex items-center gap-3 mt-1 flex-wrap">
                        <span className={`text-xs font-semibold ${job.colorText}`}>{job.type}</span>
                        <span className="text-xs text-gray-500 flex items-center gap-1">
                          <i className="ri-map-pin-line"></i>{job.location}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card body */}
                <div className="px-6 py-5">
                  <p className="text-gray-600 text-sm leading-relaxed mb-5">{job.description}</p>

                  <div className="grid grid-cols-2 gap-3 mb-5">
                    <div className="bg-gray-50 rounded-xl p-3">
                      <div className="text-xs text-gray-400 mb-1">Salaire</div>
                      <div className="text-sm font-bold text-gray-800">{job.salary}</div>
                    </div>
                    <div className="bg-gray-50 rounded-xl p-3">
                      <div className="text-xs text-gray-400 mb-1">Expérience</div>
                      <div className="text-sm font-bold text-gray-800">{job.experience}</div>
                    </div>
                  </div>

                  {/* Missions preview */}
                  <div className="mb-5">
                    <h4 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">Missions principales</h4>
                    <ul className="space-y-1.5">
                      {job.missions.slice(0, 3).map((m, i) => (
                        <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
                          <i className={`ri-check-line ${job.colorText} mt-0.5 flex-shrink-0`}></i>
                          {m}
                        </li>
                      ))}
                      <li className="text-xs text-gray-400 pl-5">+ {job.missions.length - 3} autres missions...</li>
                    </ul>
                  </div>

                  <button
                    onClick={() => openModal(job.id, job.title)}
                    className={`w-full flex items-center justify-center gap-2 ${job.color} hover:opacity-90 text-white font-semibold py-3 rounded-xl transition-all cursor-pointer whitespace-nowrap`}
                  >
                    <i className="ri-send-plane-line"></i>
                    Postuler à cette offre
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Candidature spontanée */}
      <section id="candidature" className="py-20 bg-gray-50">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-3">Candidature spontanée</h2>
            <p className="text-gray-500">Vous ne trouvez pas le poste idéal ? Envoyez-nous votre candidature, nous gardons votre profil.</p>
          </div>

          {submitted ? (
            <div className="bg-teal-50 border border-teal-200 rounded-2xl p-10 text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                <i className="ri-check-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-teal-800 mb-2">Candidature envoyée !</h3>
              <p className="text-teal-600">Merci pour votre intérêt. Nous reviendrons vers vous dans les 48h.</p>
            </div>
          ) : (
            <form
              data-readdy-form
              onSubmit={handleSubmit}
              className="bg-white rounded-2xl border border-gray-100 p-8 space-y-5"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1.5">Prénom *</label>
                  <input name="prenom" type="text" required placeholder="Jean" className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-teal-400 transition-colors" />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1.5">Nom *</label>
                  <input name="nom" type="text" required placeholder="Dupont" className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-teal-400 transition-colors" />
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1.5">Email *</label>
                  <input name="email" type="email" required placeholder="jean@email.com" className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-teal-400 transition-colors" />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1.5">Téléphone *</label>
                  <input name="telephone" type="tel" required placeholder="+41 79 000 00 00" className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-teal-400 transition-colors" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">Poste souhaité *</label>
                <select name="poste" required className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-teal-400 transition-colors bg-white cursor-pointer">
                  <option value="">Sélectionnez un poste</option>
                  <option value="Électricien Certifié">Électricien Certifié</option>
                  <option value="Technicien Maintenance">Technicien Maintenance Multi-Services</option>
                  <option value="Agent de Nettoyage">Agent de Nettoyage &amp; Conciergerie</option>
                  <option value="Aide à Domicile">Aide à Domicile / Auxiliaire de Vie</option>
                  <option value="Autre">Autre / Candidature spontanée</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">Expérience professionnelle *</label>
                <select name="experience" required className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-teal-400 transition-colors bg-white cursor-pointer">
                  <option value="">Votre niveau d'expérience</option>
                  <option value="Débutant (moins d'1 an)">Débutant (moins d'1 an)</option>
                  <option value="Junior (1-3 ans)">Junior (1-3 ans)</option>
                  <option value="Confirmé (3-7 ans)">Confirmé (3-7 ans)</option>
                  <option value="Senior (7 ans et plus)">Senior (7 ans et plus)</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                  Message de motivation *
                  <span className="text-gray-400 font-normal ml-2">({charCount}/500)</span>
                </label>
                <textarea
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  placeholder="Présentez-vous brièvement et expliquez pourquoi vous souhaitez rejoindre CasaReNovaPlus..."
                  onChange={(e) => setCharCount(e.target.value.length)}
                  className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-teal-400 transition-colors resize-none"
                />
                {charCount >= 500 && (
                  <p className="text-red-500 text-xs mt-1">Limite de 500 caractères atteinte.</p>
                )}
              </div>
              <button
                type="submit"
                disabled={submitting || charCount > 500}
                className="w-full flex items-center justify-center gap-2 bg-teal-500 hover:bg-teal-600 disabled:opacity-60 text-white font-semibold py-3.5 rounded-xl transition-all cursor-pointer whitespace-nowrap"
              >
                {submitting ? (
                  <><i className="ri-loader-4-line animate-spin"></i> Envoi en cours...</>
                ) : (
                  <><i className="ri-send-plane-line"></i> Envoyer ma candidature</>
                )}
              </button>
            </form>
          )}
        </div>
      </section>

      {/* Modal postuler */}
      {selectedJob !== null && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={closeModal}>
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>
          <div
            className="relative bg-white rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {(() => {
              const job = jobs.find(j => j.id === selectedJob);
              if (!job) return null;
              return (
                <>
                  <div className={`${job.colorLight} px-6 py-5 flex items-center justify-between`}>
                    <div className="flex items-center gap-3">
                      <div className={`w-10 h-10 flex items-center justify-center ${job.color} rounded-xl`}>
                        <i className={`${job.icon} text-lg text-white`}></i>
                      </div>
                      <div>
                        <h3 className="font-bold text-gray-900">{job.title}</h3>
                        <p className={`text-xs ${job.colorText} font-semibold`}>{job.type} · {job.location}</p>
                      </div>
                    </div>
                    <button onClick={closeModal} className="w-8 h-8 flex items-center justify-center rounded-full bg-white/60 hover:bg-white text-gray-600 transition-all cursor-pointer">
                      <i className="ri-close-line"></i>
                    </button>
                  </div>

                  <div className="p-6 space-y-6">
                    {/* Détails complets */}
                    <div>
                      <h4 className="font-bold text-gray-800 mb-3 flex items-center gap-2">
                        <i className={`ri-list-check ${job.colorText}`}></i> Toutes les missions
                      </h4>
                      <ul className="space-y-2">
                        {job.missions.map((m, i) => (
                          <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
                            <i className={`ri-check-line ${job.colorText} mt-0.5 flex-shrink-0`}></i>{m}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-800 mb-3 flex items-center gap-2">
                        <i className={`ri-user-settings-line ${job.colorText}`}></i> Profil recherché
                      </h4>
                      <ul className="space-y-2">
                        {job.requirements.map((r, i) => (
                          <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
                            <i className={`ri-arrow-right-s-line ${job.colorText} mt-0.5 flex-shrink-0`}></i>{r}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-800 mb-3 flex items-center gap-2">
                        <i className={`ri-gift-line ${job.colorText}`}></i> Ce que nous offrons
                      </h4>
                      <ul className="space-y-2">
                        {job.benefits.map((b, i) => (
                          <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
                            <i className={`ri-star-line ${job.colorText} mt-0.5 flex-shrink-0`}></i>{b}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="pt-2 border-t border-gray-100">
                      <p className="text-sm text-gray-500 mb-4">Pour postuler, utilisez le formulaire ci-dessous ou contactez-nous directement.</p>
                      <div className="flex flex-col sm:flex-row gap-3">
                        <a
                          href="#candidature"
                          onClick={closeModal}
                          className={`flex-1 flex items-center justify-center gap-2 ${job.color} hover:opacity-90 text-white font-semibold py-3 rounded-xl transition-all cursor-pointer whitespace-nowrap`}
                        >
                          <i className="ri-send-plane-line"></i>
                          Postuler maintenant
                        </a>
                        <a
                          href="mailto:info@casarenovaplus.ch"
                          className="flex-1 flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 rounded-xl transition-all cursor-pointer whitespace-nowrap"
                        >
                          <i className="ri-mail-line"></i>
                          Envoyer un email
                        </a>
                      </div>
                    </div>
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
